import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface PageContentSection {
  id: string;
  page_name: string;
  section_key: string;
  content: Record<string, any>;
  is_active: boolean;
}

export const usePageContent = (pageName: string) => {
  const [content, setContent] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadContent = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('page_content')
        .select('*')
        .eq('page_name', pageName)
        .eq('is_active', true);

      if (error) throw error;

      const contentMap: Record<string, any> = {};
      data?.forEach((item: any) => {
        contentMap[item.section_key] = item.content;
      });

      setContent(contentMap);
    } catch (err: any) {
      console.error('Error loading page content:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadContent();
  }, [pageName]);

  const getSection = <T,>(sectionKey: string, defaultValue: T): T => {
    return content[sectionKey] || defaultValue;
  };

  return { content, loading, error, getSection, refetch: loadContent };
};

export default usePageContent;
